export default {
    'username': {
        display: {
            name: '姓名',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'username',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'org_name': {
        display: {
            name: '單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'org_name',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'email': {
        display: {
            name: '電子郵件',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'email',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
            name: 'email'
        }
    },
    'original_password': {
        display: {
            name: '原始密碼',
            type: 'password',
        },
        source: {
            type: 'db',
            key: null,
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: false,
            type: 'password',
            name: 'original_password',
        }
    },
    'new_password': {
        display: {
            name: '新密碼',
            type: 'password',
        },
        source: {
            type: 'db',
            key: 'new_password',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: false,
            type: 'password',
            placeholder: '至少八碼，包含英文大寫、英文小寫、數字、特殊字元其中三種',
            name: 'new_password',
            validator: [{ 
                required: true, 
                message: '至少八碼，包含英文大寫、英文小寫、數字、特殊字元其中三種', 
                trigger: 'change', 
                //pattern: /^[0-9a-zA-Z]{6,20}$/ 
                validator: (rule, value, callback) => {
                    if (/(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/.test(value) !== true) {
                        callback(new Error('至少八碼，包含英文大寫、英文小寫、數字、特殊字元其中三種'));
                    } 
                    else {
                      callback();
                    }
                }
            }],
        }
    },
    'confirm_password': {
        display: {
            name: '確認新密碼',
            type: 'password',
        },
        source: {
            type: 'db',
            key: null,
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: false,
            type: 'password',
            placeholder: '請重複輸入一次新密碼',
            name: 'confirm_password',
            validator: [{required: true, message: '請重複輸入一次新密碼', trigger: 'change'}],
        }
    },
}
  